import UserDataService from "src/function/UserDataService";

export interface GetUserBalance {
  status: boolean,
  balance: {
    [key: string]: number,
  }
}

const useFetchUserBalance = () => {

  async function getUserBalance(id: number): Promise<GetUserBalance> {
    const userBalance = await UserDataService.getUserBalance(id);

    if (userBalance.status === 'ok') {
      return {
        status: true,
        balance: userBalance.data.balance
      }
    } else {
      return {
        status: false,
        balance: {}
      }
    }
  }


  return { getUserBalance }
}

export default useFetchUserBalance